import { Box, Typography, Stack } from "@mui/material"
import { GetAverageResult } from "../../global/Format"
import { AverageUsageLoader } from "../../loader/Loader"

export const UserSummary = ({graphDatasets, __SESSION, percentage, loader})=>{
    
    return(
        loader ? 
            <AverageUsageLoader/>
        :
            <Box minHeight="72px" display="flex">
                <Box p="16px" display="flex" alignItems="center" gap="24px" bgcolor="#FBFCFB" borderRadius="12px">
                    <Stack direction="row" alignItems="center" gap="12px">
                        {/* <Avatar src={JSON.parse(__SESSION.data.pinfo[0].profile).profile} sx={{height:40, width:40, border:'2px solid #D6D9DB'}}/> */}
                        {graphDatasets.data.assigned_id === 0 ?
                            <Typography fontWeight={600} fontSize={16} lineHeight="120%" letterSpacing="-0.75%" color="#292C2F">{ !__SESSION.data.pinfo[0] ? 'Hero User' : (`${__SESSION.data.pinfo[0]?.last_name}, ${__SESSION.data.pinfo[0]?.first_name} ${__SESSION.data.pinfo[0]?.middle_name}`)}</Typography>
                        :
                           <Typography fontWeight={600} fontSize={16} lineHeight="120%" letterSpacing="-0.75%" color="#292C2F">{graphDatasets.data.last_name}, {graphDatasets.data.first_name} {graphDatasets.data.middle_name}</Typography>
                        }
                    </Stack>
                    <Stack direction="row" alignItems="center" gap="16px">
                        <Typography fontWeight={700} fontSize={20} lineHeight="132%" letterSpacing="-1%" color="#292C2F">{percentage}%</Typography>
                        <Box height="26px" p="4px 12px 4px 12px" bgcolor="#292C2F" borderRadius="12px">
                            <Typography fontWeight={400} fontSize={12} lineHeight="147%" letterSpacing="0%" color="#F2FFF2">{GetAverageResult(percentage)}</Typography>
                        </Box>
                    </Stack>
                </Box>
            </Box>
    )
}